import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";

function App() {
  useEffect(() => {
    document.title = "Coastal Plains Garage Door, LLC — (361) 329-9550";
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            unstyled: false,
            classNames: {
              toast:
                "!rounded-none !border !border-black !bg-white !text-black !shadow-[4px_4px_0px_#0A0A0A] !font-mono",
              title: "!font-semibold !uppercase !tracking-wider !text-sm",
              description: "!text-zinc-700 !text-xs",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
